module.exports = __webpack_public_path__ + "media/images/emblems/Echallens-coat_of_arms-3bbc2bb3332b3dbe67f5933aa19a6280.svg";